<template>
  <section>
    <overlay-alert
      :show-progress="showProgress"
      :process-alert="processAlert"
    />
    <upload-document
      v-if="showUploadForm"
      :form-sub-title="formSubTitle"
      @upload-success="onUploadSuccess"
      @closed="showUploadForm = false"
    />
    <br>
    <p class="p-style">
      Step 1: Location/Document Verification
    </p>
    <div v-if="isContractorDocVerifyFailed">
      <p
        v-for="(item, i) in contractorDocVerificationStatus.expired_documents"
        :key="i"
        class="fail-message-style"
      >
        <font>
          <v-icon
            size="30"
            color="#C62828"
          >
            mdi-close-thick
          </v-icon>
          {{ item.document_type.name }} is expired, please upload the renewed file.
        </font>
      </p>
    </div>
    <p
      v-if="verificationFailed"
      class="fail-message-style"
    >
      <font>
        <v-icon
          size="30"
          color="#C62828"
        >
          mdi-close-thick
        </v-icon>
        {{ verificationFailedMessage }}
      </font>
    </p>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-btn
        color="#37474F"
        class="upload-btn"
        outlined
        small
        @click="openUploadForm()"
      >
        <v-icon left>
          mdi-cloud-upload
        </v-icon>
        Document
      </v-btn>
      <v-card-text class="justify-center">
        <v-container fluid>
          <div class="user-div">
            <p class="user-content">
              Name:- <font class="font-my-style">
                {{ userDetails.service_provider.first_name }} {{ userDetails.service_provider.last_name }}
              </font>
            </p>
            <p class="user-content">
              Mobile:- <font class="font-my-style">
                {{ userDetails.service_provider.phone_number }}
              </font>
            </p>
            <p class="user-content">
              Company:- <font class="font-my-style">
                {{ userDetails.service_provider.company.company_name }}
              </font>
            </p>
            <p class="user-content">
              Category:- <font
                v-if="userDetails.service_provider.contractor_category !== null"
                class="font-my-style"
              >
                {{ userDetails.service_provider.contractor_category.name }}
              </font>
              <font v-else>
                N/A
              </font>
            </p>
            <p class="user-content">
              Check-In Types:-<font
                class="font-my-style"
              >
                {{ userDetails.service_provider.type | arrangePretty }}
              </font>
            </p>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="#37474F"
              @click="cancel()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="#FF3700"
              :light="locationFetchFailed"
              :disabled="locationFetchFailed"
              @click="doAllVerificationChecks()"
            >
              Next
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-container>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
    <browser-loc-permission-setting
      v-if="showBrowserLocSettingsForm"
      :error-message="verificationFailedMessage"
      @closed="showBrowserLocSettingsForm = false"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import OverlayAlert from 'src/views/components/OverlayAlert';
import UploadDocument from './UploadDocument.vue';
import BrowserLocPermissionSettings from '../../BrowserLocPermissionSettings.vue';

export default {
  name: 'LocationVerification',
  components: {
    'centre-spinner': spinner,
    'overlay-alert': OverlayAlert,
    'upload-document': UploadDocument,
    'browser-loc-permission-setting': BrowserLocPermissionSettings,
  },
  filters: {
    arrangePretty (val) {
      return val.join(', ');
    },
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
    verificationFailed: false,
    verificationFailedMessage: '',
    showProgress: false,
    processAlert: '',
    latitudeValue: null,
    longitudeValue: null,
    showUploadForm: false,
    formSubTitle: '',
    locationFetchFailed: false,
    showBrowserLocSettingsForm: false,
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    userDetails () {
      return this.$store.getters.getUser;
    },
    contractorDocVerificationStatus () {
      return this.$store.getters['swiftuser/getContractorDocVerifyStatus'];
    },
    isContractorDocVerifyFailed () {
      if (Object.keys(this.contractorDocVerificationStatus).length > 0 && this.contractorDocVerificationStatus.verification_status === 'failed') {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.fetchLocationDetails();
  },
  methods: {
    fetchLocationDetails () {
      if (navigator.geolocation) {
        this.showProgress = true;
        this.processAlert = 'Checking In...';
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        this.showProgress = false;
        this.verificationFailed = true;
        this.verificationFailedMessage = 'Geolocation is not supported by this browser.';
      }
    },
    showPosition (position) {
      this.latitudeValue = position.coords.latitude;
      this.longitudeValue = position.coords.longitude;
      this.showProgress = false;
    },
    showError (error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'User denied the request for location access. Please close the tab and relaunch our app once access is enabled.';
          this.showBrowserLocSettingsForm = true;
        break;
        case error.POSITION_UNAVAILABLE:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'Location information is unavailable.';
        break;
        case error.TIMEOUT:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'The request to get user location timed out.';
        break;
        case error.UNKNOWN_ERROR:
          this.showProgress = false;
          this.locationFetchFailed = true;
          this.verificationFailed = true;
          this.verificationFailedMessage = 'An unknown error occurred.';
        break;
      }
    },
    async doAllVerificationChecks () {
      this.loading = true;
      this.$store.dispatch('swiftuser/clearScannedLocationName');
      this.$store.dispatch('swiftuser/clearContractorDocVerifyStatus');
      const siteId = this.$route.params.siteId;
      await this.$store.dispatch('swiftuser/verifyLocation', {
        site_id: siteId,
        checkin_latitude: this.latitudeValue.toString(),
        checkin_longitude: this.longitudeValue.toString(),
        checkin_type: 'check-in',
      }).then(response => {
        this.$store.dispatch('swiftuser/verifyDocuments', {
          type: 'contractor',
        }).then(response => {
          this.loading = false;
          if (this.isContractorDocVerifyFailed === true) {
            return;
          }
          this.$emit('verification-completed');
        }).catch(error => {
          this.loading = false;
          this.verificationFailed = true;
          this.verificationFailedMessage = error.response.data.message;
        });
      }).catch(error => {
        this.loading = false;
        this.verificationFailed = true;
        this.verificationFailedMessage = error.response.data.message;
      });
    },
    openUploadForm () {
      this.formSubTitle = 'Please upload your expired documents here.';
      this.showUploadForm = true;
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
    onUploadSuccess () {
      this.showUploadForm = false;
      this.verificationFailed = false;
      this.verificationFailedMessage = '';
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
  color: #546E7A;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
  text-transform: capitalize;
}
.user-div {
  line-height:normal;
  border-left: 3px solid #FF3700;
  margin-bottom: 40px;
  margin-top: 20px;
}
.fail-message-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family: 'Times New Roman', Times, serif;
  text-align: center;
}
.upload-btn {
  float: right;
  margin-right: 20px;
}
</style>
